<div class="view-text">
    <p class="mb-0">
        {{ viewText }}
        @if (isCollapsed) {
            <span class="text-primary pointer mx-2" (click)="toggleView()"> {{ "common.form.button.read_more" | translate }} </span>
        }
    </p>
</div>
